import assetUtils, { Asset } from 'app-lib/assetUtils'
import { AnyProvider } from 'app-lib/providerUtils'
import { chainConfigs } from 'bzx-common/src/config/appConfig'
import { Contract } from 'ethers5'
import { AbiCoder } from 'ethers5/lib/utils'
import { BigNumber } from '@0x/utils'
import { DexDataPayload, TradeType } from './types'

async function getSushiRouteIn(
  provider: AnyProvider,
  params: { srcToken: Asset; destToken: Asset; amountUsed: BigNumber }
): Promise<[string, BigNumber]> {
  const { srcToken, destToken, amountUsed } = params
  const ethersProvider = provider.ethersProvider
  const chainId = provider.currentChainId
  const abi = [
    'function dexAmountInFormatted(bytes calldata payload, uint256 amountOut) external returns (uint256)',
  ]
  const sushiAddress = chainConfigs[chainId].dexesDetails.SUSHI?.address
  if (!sushiAddress) {
    throw new Error('Sushi address not found')
  }
  const swapContract = new Contract(sushiAddress, abi, ethersProvider)
  const abiCoder = new AbiCoder()
  const payloadMarking = abiCoder.encode(
    ['address', 'address'],
    [assetUtils.getAddress(chainId, srcToken), assetUtils.getAddress(chainId, destToken)]
  )
  const resultant = await swapContract.callStatic.dexAmountInFormatted(
    payloadMarking,
    amountUsed.integerValue().toString()
  )
  return ['0x', new BigNumber(resultant._hex)]
}

async function getSushiRouteOut(
  provider: AnyProvider,
  params: { srcToken: Asset; destToken: Asset; amountUsed: BigNumber }
): Promise<[string, BigNumber]> {
  const { srcToken, destToken, amountUsed } = params
  const chainId = provider.currentChainId
  const abi = [
    'function dexAmountOutFormatted(bytes calldata payload, uint256 amountOut) external returns (uint256)',
  ]
  const sushiAddress = chainConfigs[chainId].dexesDetails.SUSHI?.address
  if (!sushiAddress) {
    throw new Error('Sushi address not found')
  }
  const swapContract = new Contract(sushiAddress, abi, provider.ethersProvider)
  const abiCoder = new AbiCoder()
  const payloadMarking = abiCoder.encode(
    ['address', 'address'],
    [assetUtils.getAddress(chainId, srcToken), assetUtils.getAddress(chainId, destToken)]
  )
  const resultant = await swapContract.callStatic.dexAmountOutFormatted(
    payloadMarking,
    amountUsed.integerValue().toString()
  )
  return ['0x', new BigNumber(resultant._hex)]
}

async function getSushiRoute(provider: AnyProvider, payload: DexDataPayload) {
  return payload.direction === TradeType.EXACT_INPUT
    ? getSushiRouteOut(provider, payload)
    : getSushiRouteIn(provider, payload)
}

export default {
  getSushiRouteIn,
  getSushiRouteOut,
  getSushiRoute,
}
